import Vue from 'vue'
import pinyin4js from 'pinyin4js'

function addPreZero(num) {
  return (`00${num}`).slice(-2)
}

function addPreZeroByLength(num, len) {
  let pre
  for (let index = 0; index < len; index++) {
    pre += '0'
  }

  return (pre + num).slice(-len)
}

function isEmptyObject(e) {
  let t
  for (t in e) {
    return !1
  }
  return !0
}
function hasVariantSession(k) {
  let result = window.sessionStorage.getItem(k)
  return !isEmptyObject(result)
}
const Util = {
  install(Vue) {
    Vue.prototype.util = this.util
  },
  util: {
    toDate(timestamp) {
      return new Date(timestamp)
    },
    toDateString(date) {
      return [
        date.getFullYear(),
        addPreZero(date.getMonth() + 1),
        addPreZero(date.getDate())
      ].join('-')
    },
    toTimeString(date) {
      return [
        addPreZero(date.getHours()),
        addPreZero(date.getMinutes()),
        addPreZero(date.getSeconds())
      ].join(':')
    },
    toDateTimeString(date) {
      return `${this.toDateString(date)} ${this.toTimeString(date)}`
    },
    getImageUrl(url, cut) {
      if (!url) {
        url = 'file/wiki/371a6245-0588-4d64-819b-1c9e7b873eb3.png'
      }

      if (cut) {
        url = `http://foodsafety.yonghui.cn/resource/${url}`
        return `${url.substring(0, url.lastIndexOf('.'))}_${cut}${url.substring(url.lastIndexOf('.'))}`
      } else {
        return `http://foodsafety.yonghui.cn/resource/${url}`
      }
    },
    getImageUrlOrElse(url, cut, els) {
      if (url === null || url === undefined || url === '') {
        return els
      } else {
        this.getImageUrl(url, cut)
      }
    },
    string2Array(s) {
      if (s) {
        return s.split(',')
      } else {
        return ['file/wiki/371a6245-0588-4d64-819b-1c9e7b873eb3.png']
      }
    },
    getHead(array) {
      return array[0]
    },
    fill(start, end) {
      let array = []
      for (let i = start; i <= end; i++) {
        array.push(i)
      }
      return array
    },
    randomString(len) {
      len = len || 32
      let $chars = 'abcdefghijklmnopqrstuvwxyz',
        maxPos = $chars.length,
        pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    formatMoney(number, places, symbol, thousand, decimal) {
      number = number || 0
      places = !isNaN(places = Math.abs(places)) ? places : 2
      symbol = symbol !== undefined ? symbol : '$'
      thousand = thousand || ','
      decimal = decimal || '.'
      var negative = number < 0 ? '-' : '',
        i = `${parseInt(number = Math.abs(+number || 0).toFixed(places), 10)}`,
        j = (j = i.length) > 3 ? j % 3 : 0
      return symbol + negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousand}`) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '')
    },
    formatPercentage(number) {
      return `${Math.abs(number).toFixed(2) * 100}%`
    },
    duration2Time(duration) {
      const ss = Math.ceil(duration % 60).toString().padStart(2, '0')

      const mm = Math.floor(duration / 60).toString().padStart(2, '0')

      const HH = Math.floor(duration / 3600).toString().padStart(2, '0')

      return `${HH}:${mm}:${ss}`
    },
    groupBy(array, f) {
      let groups = {}
      array.forEach((o) => {
        let group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map((group) => groups[group])
    },
    animateCSS(element, animationNames, callback) {
      const node = document.querySelector(element)
      const animationNameArray = ['animated', ...animationNames.split(' ')]
      node.classList.add(...animationNameArray)

      function handleAnimationEnd() {
        node.classList.remove(...animationNameArray)
        node.removeEventListener('animationend', handleAnimationEnd)

        if (typeof callback === 'function') callback()
      }

      node.addEventListener('animationend', handleAnimationEnd)
    },
    getFileType(e) {
      if (e.endsWith('.png') || e.endsWith('.PNG')) {
        return 'IMAGE'
      }
      if (
        e.endsWith('.jpg') ||
                e.endsWith('.JPG') ||
                e.endsWith('.jpeg') ||
                e.endsWith('.JPEG')
      ) {
        return 'IMAGE'
      }
      if (e.endsWith('.mp4')) {
        return 'VIDEO'
      }
      if (e.endsWith('.mp3')) {
        return 'AUDIO'
      }
      return 'UNKNOW'
    },
    getFileLevel(e) {
      switch (e.type) {
        case 'VIDEO': return 3
        case 'IMAGE': return 2
        case 'AUDIO': return 1
        default: return 0
      }
    },
    getFileList(files) {
      let result = []
      if (files) {
        const array = files.split(',')
        if (array.length > 0) {
          array.forEach(e => {
            result.push({
              type: this.getFileType(e),
              src: e
            })
          })
        }
      }
      return result.sort((a, b) => this.getFileLevel(b) - this.getFileLevel(a))
    },
    getFirstImage(files, cut) {
      const fileList = this.getFileList(files)

      const first = fileList.find(e => e.type === 'IMAGE')

      if (first) {
        return this.getImageUrl(first.src, cut)
      } else {
        return this.getImageUrl(false)
      }
    },
    sortByPinyin(array, k) {
      // 需要被排序的数组
      const list = array
      // 对需要排序的数字和位置的临时存储
      const mapped = list.map((el, i) => ({ index: i, value: pinyin4js.getShortPinyin(el[k]) }))
      // 按照多个值排序数组
      mapped.sort((a, b) => +(a.value > b.value) || +(a.value === b.value) - 1)
      // 根据索引得到排序的结果
      const result = mapped.map((el) => list[el.index])
      return result
    },
    // SessionStorage
    setVariantSession(k, v) {
      if (!isEmptyObject(k)) {
        window.sessionStorage.setItem(k, JSON.stringify(v))
      }
    },
    removeVariantSession(k) {
      window.sessionStorage.removeItem(k)
    },
    getVariantSession(k) {
      if (hasVariantSession(k)) {
        return JSON.parse(window.sessionStorage.getItem(k))
      } else {
        return null
      }
    },
    shareWxUrl() {
      let url
      if (window.location.origin === 'http://fresh-wiki.yonghui.cn') {  // 生产环境
        url = 'http://pc-mid-p.wiki-fresh-share-product-h5.apis.yonghui.cn'
      } else {
        url = 'http://sit.wiki-fresh-share-product-h5.sitapis.yonghui.cn'
      }
      return url
    }
  }
}

export default Util.util

Vue.use(Util)
